import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-display-result-dialog',
  templateUrl: './display-result-dialog.component.html',
  styleUrls: ['./display-result-dialog.component.css']
})
export class DisplayResultDialogComponent implements OnInit {
  result: any;
  filename: any;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
        this.result = this.data['res'];
        this.filename = this.data['filename'];
    }

  printComponent(cmpName) {
    const printContent = document.getElementById(cmpName);
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
}

}
